import PropTypes from "prop-types";

// use this propType whenever your linter complains that
//   'children' is missing in props validation (react/prop-types)
export const childrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);
